import React from 'react';
import { Label, Text, ToggleGroup, ToggleGroupItem } from '@musa.tech/design-system';

export type OnDemandService = 'collect' | 'bucket';

/**
 * Coleta e movimentação de equipamento têm contratos e pedidos diferentes; o gerador escolhe
 * antes do contrato.
 */
export const ServiceTypeToggle: React.FC<{
  value: OnDemandService;
  onChange: (value: OnDemandService) => void;
}> = ({ value, onChange }) => (
  <div className="flex flex-col gap-1">
    <Label>
      <Text variant="label" size="small" className="text-neutral-700">
        O que você precisa
      </Text>
    </Label>
    <ToggleGroup
      type="single"
      value={value}
      // o ToggleGroup devolve vazio ao clicar no item já ativo; sempre há um serviço escolhido
      onValueChange={(next) => next && onChange(next as OnDemandService)}
      className="justify-start"
      aria-label="Tipo de serviço"
    >
      <ToggleGroupItem value="collect">Coleta</ToggleGroupItem>
      <ToggleGroupItem value="bucket">Movimentação de Equipamento</ToggleGroupItem>
    </ToggleGroup>
  </div>
);
